import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/services/modal.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(
    private scroller: ViewportScroller,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
  }

  openLoginModal() {
    this.modalService.openLogin();
  }
}
